import { css } from 'styled-components';
import { BOTTOM_CONTROLS_HEIGHT, SUBTITLES_BOTTOM_SPACING } from "../../constants";
export var createTextTrackDisplayCss = function createTextTrackDisplayCss(_ref) {
  var isReady = _ref.isReady,
    visibleUi = _ref.visibleUi,
    isMd = _ref.isMd,
    isSm = _ref.isSm,
    isXs = _ref.isXs;
  if (!isReady) {
    return "\n      display: none;\n    ";
  }
  var transformTransitionCss = /*#__PURE__*/css(["\n    transition: ", ";\n  "], function (_ref2) {
    var theme = _ref2.theme;
    return theme.transition('transform', 300);
  });
  if (isMd) {
    return css(["\n      ", "\n      padding-left: 24px;\n      padding-right: 24px;\n      transform: translateY(\n        calc(\n          -100% - ", "px\n        )\n      );\n    "], transformTransitionCss, visibleUi ? BOTTOM_CONTROLS_HEIGHT.md : SUBTITLES_BOTTOM_SPACING.md);
  }
  if (isSm) {
    return css(["\n      ", "\n      padding-left: 20px;\n      padding-right: 20px;\n      transform: translateY(\n        calc(\n          -100% - ", "px\n        )\n      );\n    "], transformTransitionCss, visibleUi ? BOTTOM_CONTROLS_HEIGHT.sm : SUBTITLES_BOTTOM_SPACING.sm);
  }
  if (isXs) {
    return css(["\n      ", "\n      padding-left: 16px;\n      padding-right: 16px;\n      transform: translateY(\n        calc(\n          -100% - ", "px\n        )\n      );\n    "], transformTransitionCss, visibleUi ? BOTTOM_CONTROLS_HEIGHT.xs : SUBTITLES_BOTTOM_SPACING.xs);
  }
  return css(["\n    padding-left: 8px;\n    padding-right: 8px;\n    transform: calc(-100% - ", "px);\n    ", "\n  "], SUBTITLES_BOTTOM_SPACING.xxs, visibleUi ? "\n        visibility: hidden;\n        opacity: 0;\n        transition: visibility 0s 150ms, opacity 150ms linear;\n      " : "\n        visibility: visible;\n        opacity: 1;\n        transition: opacity 150ms linear;\n      ");
};
export var textTrackCueCss = /*#__PURE__*/css(["\n  font-family: Nunito;\n  color: ", ";\n  background-color: ", ";\n  background-clip: border-box;\n"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.white;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.base['main-80'];
});